import { Bell, Settings, ChevronDown, UserCog, LogOut, User, ShieldCheck } from 'lucide-react';
import { useState, useRef } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { Button } from '../ui/button';
import { useAuth } from '../../graphql/hooks/useAuth';
import { useNotifications } from '../../contexts/NotificationsContext';
import { NotificationDropdown } from '../NotificationDropdown';

interface TopBarProps {
  pageTitle: string;
  dateContext: string;
  userName: string;
  userRole: 'user' | 'admin' | string;
  onSettingsClick?: () => void;
  onProfileClick?: () => void;
  onNavigateToRequest?: (requestId: string) => void;
  onNavigateToPage?: (page: string) => void;
}

export function TopBar({ 
  pageTitle, 
  dateContext, 
  userName, 
  userRole, 
  onSettingsClick,
  onNavigateToRequest,
  onProfileClick,
  onNavigateToPage
}: TopBarProps) {
  const { signOut } = useAuth();
  const { unreadCount } = useNotifications();
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const bellButtonRef = useRef<HTMLButtonElement>(null);

  const handleLogout = () => {
    signOut();
  };

  const handleBellClick = () => {
    setIsNotificationOpen(!isNotificationOpen);
  };

  const handleNavigateToRequest = (requestId: string) => {
    if (onNavigateToRequest) {
      onNavigateToRequest(requestId);
    }
  };

  const handleNavigateToPage = (page: string) => {
    if (onNavigateToPage) {
      onNavigateToPage(page);
    }
  };

  return (
    <div className="bg-white border border-[#e9e9e9] min-h-[93px] px-4 md:px-8 flex items-center justify-between rounded-[16px] my-4 shadow-sm">
      <div className="lg:ml-0 ml-16">
        <div className="flex items-center gap-3">
          <h1 className="text-[#1c1c1c] text-[20px] md:text-[24px] font-medium leading-tight md:leading-[36px]">
            {pageTitle}
          </h1>
        </div>
        <p className="text-[#6b6b6b] text-[14px] md:text-[16px]">{dateContext}</p>
      </div>
      <div className="flex items-center gap-2 md:gap-4">
        {/* Notification Bell */}
        {/* <div className="relative">
          <Button 
            ref={bellButtonRef}
            variant="ghost" 
            size="icon" 
            className="relative rounded-[10px] size-[36px]"
            onClick={handleBellClick}
          >
            <Bell className="size-5 text-[#1c1c1c]" />
            {unreadCount > 0 && (
              <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 bg-[#dc2626] text-white text-[11px] font-medium rounded-full flex items-center justify-center">
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </Button>

          <NotificationDropdown
            isOpen={isNotificationOpen}
            onClose={() => setIsNotificationOpen(false)}
            onNavigateToRequest={handleNavigateToRequest}
            onNavigateToPage={handleNavigateToPage}
            triggerRef={bellButtonRef}
          />
        </div> */}

        <Button 
          variant="ghost" 
          size="icon" 
          className="rounded-[10px] size-[36px] hidden md:flex"
          onClick={onSettingsClick}
        >
          <Settings className="size-5 text-[#1c1c1c]" />
        </Button>
        <div className="h-12 w-px bg-[#e9e9e9] hidden md:block" />
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="flex items-center gap-2 md:gap-3 hover:bg-[#f5f5f5] rounded-[10px] pr-2 transition-colors">
              <div className="text-right hidden md:block">
                <p className="text-[#1c1c1c] text-[16px]">{userName}</p>
                <p className="text-[#6b6b6b] text-[14px] capitalize">{userRole}</p>
              </div>
              <div className="size-10 bg-[#0084c7] rounded-full flex items-center justify-center text-white font-medium">
                {userName.charAt(0)}
              </div>
              <ChevronDown className="size-4 text-[#6b6b6b] hidden md:block" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-[200px]">
            <DropdownMenuItem 
              onClick={onProfileClick}
              className="cursor-pointer"
            >
              <User className="size-4 mr-2" />
              Profil
            </DropdownMenuItem>
            <DropdownMenuItem 
              onClick={onSettingsClick}
              className="cursor-pointer"
            >
              <Settings className="size-4 mr-2" />
              Einstellungen
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem 
              onClick={handleLogout}
              className="cursor-pointer focus:bg-[#f5f5f5]"
            >
              <LogOut className="size-4 mr-2" />
              Abmelden
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
}